(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mh-collection-quick-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mh-collection-quick-filters')) {
    customElements.define('mh-collection-quick-filters', class extends HTMLElement {
      connectedCallback() {
        this.sync = () => {
          const key = this.dataset.filterKey;
          const params = new URLSearchParams(window.location.search);
          const selected = params.getAll(key).flatMap(value => value.split(','));
          this.querySelectorAll('[data-filter-value]').forEach(link => {
            const value = link.dataset.filterValue;
            const values = value.split(',').filter(Boolean);
            const active = values.length ? values.every(item => selected.includes(item)) : selected.length === 0;
            if (active) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
            const next = new URLSearchParams(params);
            next.delete('page');
            next.delete(key);
            values.forEach(item => next.append(key, item));
            const url = new URL(link.href);
            url.search = next.toString();
            link.href = url.pathname + url.search;
          });
        };
        this.schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(this.sync);
        };
        this.sync();
        window.addEventListener('popstate', this.schedule);
        window.addEventListener('pageshow', this.schedule);
        const grid = document.getElementById('ProductGridContainer');
        if (grid) {
          this.observer = new MutationObserver(this.schedule);
          this.observer.observe(grid, { childList: true, subtree: true });
        }
      }
      disconnectedCallback() {
        window.removeEventListener('popstate', this.schedule);
        window.removeEventListener('pageshow', this.schedule);
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mh-craftsmanship"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mh-craft-film')) {
    customElements.define('mh-craft-film', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const trigger = this.querySelector('[data-film-open]');
        const dialog = this.querySelector('dialog');
        const player = this.querySelector('[data-film-player]');
        trigger.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          player.replaceChildren(this.querySelector('template').content.cloneNode(true));
          dialog.showModal();
        });
        this.querySelector('[data-film-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => {
          player.replaceChildren();
          trigger.focus();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mh-mobile-carousel-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mh-mobile-carousel')) {
    customElements.define('mh-mobile-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        if (!this.track) return;
        this.previous = this.querySelector('[data-carousel-prev]');
        this.next = this.querySelector('[data-carousel-next]');
        this.counter = this.querySelector('[data-carousel-current]');
        this.update = () => {
          const left = this.track.getBoundingClientRect().left;
          const cards = Array.from(this.track.children);
          this.index = cards.reduce((closest, card, index) => Math.abs(card.getBoundingClientRect().left - left) < Math.abs(cards[closest].getBoundingClientRect().left - left) ? index : closest, 0);
          const noOverflow = this.track.scrollWidth - this.track.clientWidth < 2;
          this.previous.disabled = noOverflow || this.index === 0;
          this.next.disabled = noOverflow || this.index === cards.length - 1;
          const current = String(this.index + 1);
          if (this.counter.textContent !== current) this.counter.textContent = current;
        };
        this.schedule = () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(this.update); };
        this.move = direction => {
          const cards = this.track.children;
          const target = cards[Math.max(0, Math.min(cards.length - 1, this.index + direction))];
          if (target) this.track.scrollTo({ left: target.offsetLeft - cards[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        this.onPrevious = () => this.move(-1);
        this.onNext = () => this.move(1);
        this.onKey = event => {
          if (event.target !== this.track || !matchMedia('(max-width: 749px)').matches) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
        };
        this.previous.addEventListener('click', this.onPrevious);
        this.next.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.schedule, { passive: true });
        this.track.addEventListener('keydown', this.onKey);
        this.observer = new ResizeObserver(this.schedule);
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.previous?.removeEventListener('click', this.onPrevious);
        this.next?.removeEventListener('click', this.onNext);
        this.track?.removeEventListener('scroll', this.schedule);
        this.track?.removeEventListener('keydown', this.onKey);
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mh-product-color-stock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mh-color-stock')) {
    customElements.define('mh-color-stock', class extends HTMLElement {
      connectedCallback() {
        this.stock = JSON.parse(this.querySelector('script').textContent);
        this.productInfo = this.closest('product-info');
        if (!this.productInfo) return;
        this.updateSwatches();
        this.observer = new MutationObserver(() => this.updateSwatches());
        this.observer.observe(this.productInfo, { childList: true, subtree: true });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
      updateSwatches() {
        this.productInfo.querySelectorAll('input[type="radio"]').forEach((input) => {
          const isColor = input.dataset.globoswatchindex === this.stock.optionKey || input.dataset.optionName === this.stock.optionName;
          if (!isColor || !Object.hasOwn(this.stock.colors, input.value)) return;
          const label = this.productInfo.querySelector(`label[for="${CSS.escape(input.id)}"]`);
          if (!label) return;
          const available = this.stock.colors[input.value];
          label.dataset.mhColorStock = available ? 'available' : 'sold-out';
          label.title = input.value;
          input.setAttribute('aria-label', available ? input.value : `${input.value} — ${this.stock.soldOutText}`);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mh-product-restock-policy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mh-restock-policy')) {
    customElements.define('mh-restock-policy', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        if (!this.productInfo) return;
        const stockScript = this.productInfo.querySelector('mh-color-stock script');
        this.colorStock = stockScript ? JSON.parse(stockScript.textContent) : null;
        this.overriddenSubmitButtons = new WeakSet();
        this.onSelectionChange = () => queueMicrotask(() => {
          if (this.isConnected) this.updateNotifications();
        });
        this.productInfo.addEventListener('change', this.onSelectionChange);
        this.productInfo.addEventListener('click', this.onSelectionChange);
        this.updateNotifications();
        this.observer = new MutationObserver(() => this.updateNotifications());
        this.observer.observe(this.productInfo, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'disabled', 'checked'],
        });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.productInfo?.removeEventListener('change', this.onSelectionChange);
        this.productInfo?.removeEventListener('click', this.onSelectionChange);
      }
      setStyle(element, property, value) {
        if (element.style.getPropertyValue(property) !== value || element.style.getPropertyPriority(property) !== 'important') {
          element.style.setProperty(property, value, 'important');
        }
      }
      actionsAvailable() {
        if (this.dataset.productAvailable !== 'true') return false;
        if (!this.colorStock) return true;
        const inputs = [...this.productInfo.querySelectorAll('input[type="radio"]:checked')];
        const colorInput = inputs.find((input) => input.dataset.globoswatchindex === this.colorStock.optionKey)
          || inputs.find((input) => input.dataset.optionName === this.colorStock.optionName);
        const colorSelect = [...this.productInfo.querySelectorAll('variant-selects select')]
          .find((select) => select.name === `options[${this.colorStock.optionName}]`);
        const color = colorInput?.value || colorSelect?.value || this.dataset.selectedColor;
        return this.colorStock.colors[color] !== false;
      }
      updateNotifications() {
        const available = this.actionsAvailable();
        this.dataset.allowActions = String(available);
        this.productInfo.querySelectorAll('.timesact-button-bis').forEach((button) => {
          this.setStyle(button, 'background-color', 'rgb(38, 38, 38)');
          this.setStyle(button, 'border-color', 'rgb(38, 38, 38)');
          this.setStyle(button, 'color', 'rgb(255, 255, 255)');
        });
        this.productInfo.querySelectorAll('.product-form__submit').forEach((button) => {
          if (!available) {
            this.overriddenSubmitButtons.add(button);
            this.setStyle(button, 'display', 'inline-flex');
          } else if (this.overriddenSubmitButtons.has(button)) {
            if (button.style.getPropertyValue('display') === 'inline-flex' && button.style.getPropertyPriority('display') === 'important') {
              button.style.removeProperty('display');
            }
            this.overriddenSubmitButtons.delete(button);
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mh-shoe-stages"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mh-shoe-stages')) {
    customElements.define('mh-shoe-stages', class extends HTMLElement {
      connectedCallback() {
        this.sync = () => {
          const params = new URLSearchParams(window.location.search);
          const values = params.getAll('gf_434443').flatMap(value => value.split(','));
          this.querySelectorAll('[data-stage-value]').forEach(link => {
            const value = link.dataset.stageValue;
            const active = value ? values.includes(value) : values.length === 0;
            if (active) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
            const next = new URLSearchParams(params);
            next.delete('page');
            if (value) next.set('gf_434443', value);
            else next.delete('gf_434443');
            const url = new URL(link.href);
            url.search = next.toString();
            link.href = url.pathname + url.search;
          });
        };
        this.schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(this.sync);
        };
        this.sync();
        window.addEventListener('popstate', this.schedule);
        window.addEventListener('pageshow', this.schedule);
        const grid = document.getElementById('ProductGridContainer');
        if (grid) {
          this.observer = new MutationObserver(this.schedule);
          this.observer.observe(grid, { childList: true, subtree: true });
        }
      }
      disconnectedCallback() {
        window.removeEventListener('popstate', this.schedule);
        window.removeEventListener('pageshow', this.schedule);
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
